import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SignupService } from '../../services/signup.service';
import {Enterprise} from '../../models/enterprise';
import { MdDialog } from '@angular/material';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { Router } from '@angular/router';
import { Ng2DeviceService } from 'ng2-device-detector';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'app-register-component',
  templateUrl: './register-component.component.html',
  styleUrls: ['./register-component.component.css']
})
export class RegisterComponentComponent implements OnInit {
  deviceInfo = null;
  chrome_version = "56.0.2924";
  safari_version = "10.0.3";
  explorer_version = "10.0";
  firefox_version = "45.7.0esr";
  browser_version: string;
  errorConnection: boolean;
  noBrowserSupported: string;

  constructor(
    private fb: FormBuilder,
    private signupService: SignupService,
    private dialog: MdDialog,
    private router: Router,
    private deviceService: Ng2DeviceService,
    private configurationService: ConfigurationService
  ) { }
  loading: boolean = false;
  form: FormGroup;

  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  areEqual(group: FormGroup) {
    var valid = false;
    for (let name in group.controls) {
      var val = group.controls[name].value;
    }

    if (valid) {
      return null;
    }

    return {
      areEqual: true
    };
  }

  ngOnInit() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    if (this.deviceInfo.browser === 'chrome') {
      this.browser_version = this.chrome_version;
    } else if (this.deviceInfo.browser === 'safari') {
      this.browser_version = this.safari_version;
    } else if (this.deviceInfo.browser === 'ie') {
      this.browser_version = this.explorer_version;
    } else if (this.deviceInfo.browser === 'firefox') {
      this.browser_version = this.firefox_version;
    } else {
      this.browser_version = '';
    }

    if (this.browser_version !== '') {
      const options = {lexicographical: true, zeroExtend: true};
      const compare = this.versionCompare(this.deviceInfo.browser_version, this.browser_version, options);
      if (compare < 0) {
        this.noBrowserSupported = 'true';
      } else {
        this.noBrowserSupported = 'false';
      }
    } else {
      this.noBrowserSupported = 'true';
    }

    this.configurationService.errorHttp$.subscribe(
      response => {
        if (response) {
          this.errorConnection = true;
        } else {
          this.errorConnection = false;
        }
        // this.dialog.open(MessageBoxDialog, {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
      }
    );

      this.form = this.fb.group({
      name: ['', Validators.required],
      contact: ['', Validators.required],
      plan: ['', Validators.required],
      email: [ null, Validators.compose([ Validators.required, Validators.pattern(this.emailRegex) ]) ],
      nit: ['', Validators.required],
      telephone: ['', Validators.required],
      location: ['', Validators.required],
      jobcategory_id: ['', Validators.required],
      password: ['', Validators.required],
      password_repeat: ['', Validators.required]
    });
  }

  onPostRegister(enterprise:Enterprise) {
    this.loading = true;

    this.signupService.signup(enterprise)
      .subscribe(
        data => {
          this.loading = false;
          let strbtoa = window.btoa(JSON.stringify(
              {
                  user_id: data.data.user_id,
                  timestamp: new Date().getTime()
              })
          );
          this.dialog.open(MessageBoxDialog, {data: {message: 'Empresa Creada', success: true, showIcon:true}});
          this.router.navigate(['/login', strbtoa]);
        },
        error => {
          this.dialog.open(MessageBoxDialog, {data: {title: 'Información Dreamjobs',
            message: error.message, alert: true, showIcon: true}});
          console.log(error);
          this.loading = false;
        }
      );
  }

  gotoLogin(){this.router.navigate(['login'])}

/**
 * Compares two software version numbers (e.g. "1.7.1" or "1.2b").
 *
 * This function was born in http://stackoverflow.com/a/6832721.
 *
 * @param {string} v1 The first version to be compared.
 * @param {string} v2 The second version to be compared.
 * @param {object} [options] Optional flags that affect comparison behavior:
 * <ul>
 *     <li>
 *         <tt>lexicographical: true</tt> compares each part of the version strings lexicographically instead of
 *         naturally; this allows suffixes such as "b" or "dev" but will cause "1.10" to be considered smaller than
 *         "1.2".
 *     </li>
 *     <li>
 *         <tt>zeroExtend: true</tt> changes the result if one version string has less parts than the other. In
 *         this case the shorter string will be padded with "zero" parts instead of being considered smaller.
 *     </li>
 * </ul>
 * @returns {number|NaN}
 * <ul>
 *    <li>0 if the versions are equal</li>
 *    <li>a negative integer iff v1 < v2</li>
 *    <li>a positive integer iff v1 > v2</li>
 *    <li>NaN if either version string is in the wrong format</li>
 * </ul>
 *
 * @copyright by Jon Papaioannou (["john", "papaioannou"].join(".") + "@gmail.com")
 * @license This function is in the public domain. Do what you want with it, no strings attached.
 */
versionCompare(v1, v2, options) {
  let lexicographical = options && options.lexicographical,
      zeroExtend = options && options.zeroExtend,
      v1parts = v1.split('.'),
      v2parts = v2.split('.');

  function isValidPart(x) {
      return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
      return NaN;
  }

  if (zeroExtend) {
      while (v1parts.length < v2parts.length) v1parts.push("0");
      while (v2parts.length < v1parts.length) v2parts.push("0");
  }

  if (!lexicographical) {
      v1parts = v1parts.map(Number);
      v2parts = v2parts.map(Number);
  }

  for (let i = 0; i < v1parts.length; ++i) {
      if (v2parts.length === i) {
        return 1;
      }

      if (Number(v1parts[i]) === Number(v2parts[i])) {
        continue;
      }
      else if (Number(v1parts[i]) > Number(v2parts[i])) {
        return 1;
      }
      else {
        return -1;
      }
  }

  if (v1parts.length != v2parts.length) {
      return -1;
  }

  return 0;
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/register-component/register-component.component.ts